<template>
    <div hidden>
        <!-- Your HTML content to convert to PDF -->
        <div v-if="data_bill && data_bill.tenant_bills" ref="pdfContent" class="pt-1 p-2 pdf-document">
            <img class="watermarked" :src="Res_Guru_Logo_create06" />
            <div class="flex justify-between items-start">
                <div class="flex">
                    <div class="ml-1">
                        <div class="text-sm font-bold">{{ $store.state.buildingInfo[0]?.attributes?.buildingName }}</div>
                        <div class="text-sm">{{ $store.state.buildingInfo[0]?.attributes?.buildingAddress }}</div>
                        <div class="text-sm">โทร: {{ $store.state.buildingInfo[0]?.attributes?.buildingPhone }}</div>
                    </div>
                </div>
                <!-- QR code + bank details get injected here by generatePDF()
                     once fetched - level with the header instead of taking
                     its own row further down, so the whole document is
                     shorter and still fits in the top half of the A4 page
                     (kept as a4, not a5, so a future 2-up print can stack
                     two of these on one sheet). -->
                <div ref="qrSlot"></div>
                <div class="flex flex-col justify-between">
                    <div class="text-lg font-bold"> ใบวางบิล/ใบแจ้งหนี้ </div>
                    <div class="text-sm"> หมายเลขใบแจ้งหนี้ (invoice) {{ data_bill.tenant_bills[0]?.invoiceNumber }}</div>
                    <div class="text-sm">
                        <div>วันที่ออก {{ formatDate(data_bill.tenant_bills[0]?.createdAt) }}</div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-2 text-sm mt-1">
                <div class="pr-2">
                    <hr class="h-px">
                    <div class="font-bold mb-1">ผู้เช่า</div>
                    <div>ห้องเช่าหมายเลข {{ data_bill.RoomNumber }}</div>
                    <div>ชื่อผู้เช่า {{ data_bill.user_sign_contract?.users_permissions_user?.firstName
                    }} {{ data_bill.user_sign_contract?.users_permissions_user?.lastName }}</div>
                    <div>ที่อยู่ {{ data_bill.user_sign_contract?.users_permissions_user?.contactAddress }}</div>
                    <div>โทร: {{
                        data_bill.user_sign_contract?.users_permissions_user?.phone }}</div>
                </div>
                <div class="pr-2 text-right">
                    <hr class="h-px">
                    <div class="font-bold mb-1">กำหนดชำระ</div>
                    <div>วันที่ {{ formatDueDate(data_bill.tenant_bills[0]?.createdAt, $store.state.buildingInfo[0]?.attributes?.BuildingDueDate) }}</div>
                </div>
            </div>

            <!-- This is the table section with improved styling -->
            <div class="mt-1">
                <table class="text-sm w-full border-collapse invoice-table">
                    <thead>
                        <tr>
                            <th class="py-2 px-2 text-left border" style="width: 40%;">รายการ</th>
                            <th class="py-2 px-2 text-right border" style="width: 20%;">จำนวน</th>
                            <th class="py-2 px-2 text-right border" style="width: 20%;">ราคาต่อหน่วย</th>
                            <th class="py-2 px-2 text-right border" style="width: 20%;">ราคารวม</th>
                        </tr>
                    </thead>
                    <!-- Corrected table rows for water and electric -->
                    <tbody>
                        <tr class="row-even">
                            <td class="py-1 px-2 border">ค่าห้อง</td>
                            <td class="py-1 px-2 text-right border">1</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.roomPrice) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.roomPrice) }}</td>
                        </tr>
                        
                        <!-- CORRECTED Water Row -->
                        <tr class="row-odd">
                            <td class="py-1 px-2 border">ค่าน้ำ(
{{ formatQuantity(getWaterBeforeUnit(data_bill.tenant_bills[0])) }}
-
{{ formatQuantity(getWaterAfterUnit(data_bill.tenant_bills[0])) }})                            </td>
                            <td class="py-1 px-2 text-right border">{{ formatQuantity(data_bill.tenant_bills[0]?.usageWater || 0)}}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.waterRate || ($store.state.buildingInfo[0]?.attributes?.waterUnitPrice || 0)) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.waterPrice) }}</td>
                        </tr>
                        
                        <!-- CORRECTED Electric Row -->
                        <tr class="row-even">
                            <td class="py-1 px-2 border">
ค่าไฟ ({{
    formatQuantity(getElectricBeforeUnit(data_bill.tenant_bills[0]))
}} - {{
    formatQuantity(getElectricAfterUnit(data_bill.tenant_bills[0]))
}})                            </td>
                            <td class="py-1 px-2 text-right border">{{ formatQuantity(data_bill.tenant_bills[0]?.usageElectric || 0) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.electricRate || ($store.state.buildingInfo[0]?.attributes?.electricUnitPrice || 0)) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.electricPrice) }}</td>
                        </tr>
                        
                        <tr class="row-odd">
                            <td class="py-1 px-2 border">ค่าส่วนกลาง</td>
                            <td class="py-1 px-2 text-right border">1</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.communalPrice) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.communalPrice) }}</td>
                        </tr>
                        <tr class="row-even">
                            <td class="py-1 px-2 border">ค่าปรับ</td>
                            <td class="py-1 px-2 text-right border">1</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.otherPrice) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(data_bill.tenant_bills[0]?.otherPrice) }}</td>
                        </tr>
                        
                        <tr class="row-odd" v-if="getPastUnpaidTotal(data_bill.tenant_bills[0]) > 0">
                            <td class="py-1 px-2 border">ยอดค้างจากเดือน{{ getPreviousMonthThai(data_bill.tenant_bills[0]?.createdAt) }}</td>
                            <td class="py-1 px-2 text-right border">1</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(getPastUnpaidTotal(data_bill.tenant_bills[0])) }}</td>
                            <td class="py-1 px-2 text-right border">{{ formatNumber(getPastUnpaidTotal(data_bill.tenant_bills[0])) }}</td>
                        </tr>
                        <tr class="row-even" v-if="getCreditApplied(data_bill.tenant_bills[0]) > 0">
                            <td class="py-1 px-2 border">หักเครดิตจากยอดชำระเกินคราวก่อน</td>
                            <td class="py-1 px-2 text-right border">1</td>
                            <td class="py-1 px-2 text-right border">-{{ formatNumber(getCreditApplied(data_bill.tenant_bills[0])) }}</td>
                            <td class="py-1 px-2 text-right border">-{{ formatNumber(getCreditApplied(data_bill.tenant_bills[0])) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <!-- Bottom rows with progressively larger text -->
                    <tr>
                        <td colspan="3" class="py-1 px-2 text-right border text-sm">รวมค่าใช้จ่าย</td>
                        <td class="py-1 px-2 text-right border text-sm">{{ formatNumber(getInvoiceChargeSubtotal(data_bill.tenant_bills[0])) }}</td>
                    </tr>
                    <tr>
                        <td colspan="3" class="py-1 px-2 text-right border text-sm">ภาษี ({{ data_bill.room_building?.vat_rate || 0 }}%)</td>
                        <td class="py-1 px-2 text-right border text-sm">{{ formatNumber(getInvoiceVat(data_bill.tenant_bills[0])) }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" class="py-1 px-2 text-center border text-sm">( {{ numberToThaiText(getNetPayable(data_bill.tenant_bills[0])) }} )</td>
                        <td class="py-1 px-2 text-right font-bold border text-sm">ยอดที่ต้องชำระ</td>
                        <td class="py-1 px-2 text-right font-bold text-green-600 border text-sm">{{ formatNumber(getNetPayable(data_bill.tenant_bills[0])) }}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
            
            <div class="text-sm mt-1">
                <p>กรุณาชำระและแจ้งภายในวันที่กำหนด</p>
            </div>

            <div class="flex justify-end mt-2">
                <p class="flex flex-col items-center text-sm">
                    <span>ลงชื่อ</span>
                    <span style="height: 20px; display: block;"></span>
                    <span class="signature-line"></span>
                    <span>ผู้จัดทำ</span>
                </p>
            </div>
        </div>
    </div>
</template>
  
<script>

import html2pdf from 'html2pdf.js';
import Res_Guru_Logo_create06 from '@/assets/img/Res_Guru_Logo_create-06.png'
import Res_Guru_Logo_create12 from '@/assets/img/Res_Guru_Logo_create-12.png'
import { convertDateNoTime } from '@/components/hook/hook'
import THBText from 'thai-baht-text'
import download from 'downloadjs';
import axios from 'axios';
export default {
    data() {
        return {
            data_bill: null,
            convertDateNoTime,
            Res_Guru_Logo_create12,
            Res_Guru_Logo_create06,
            THBText
        }

    },
    // mounted() {
    //     this.generatePDF()
    // },
    methods: {
        numberToThaiText(number) {
            if (!number) return '';
            
            const digits = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
            const positions = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน'];
            
            // Split number into baht and satang
            const [baht, satang = '0'] = number.toFixed(2).split('.');
            
            const convertGroup = (num) => {
                const str = num.toString();
                let result = '';
                
                for (let i = 0; i < str.length; i++) {
                    const digit = parseInt(str[i]);
                    if (digit === 0) continue;
                    
                    // Special cases for ones
                    if (i === str.length - 1) {
                        if (digit === 1 && str.length > 1) {
                            result += 'เอ็ด';
                        } else {
                            result += digits[digit];
                        }
                    }
                    // Special cases for tens
                    else if (i === str.length - 2) {
                        if (digit === 2) {
                            result += 'ยี่';
                        } else if (digit === 1) {
                            result += '';
                        } else {
                            result += digits[digit];
                        }
                        result += positions[1];
                    }
                    // Other positions
                    else {
                        result += digits[digit] + positions[str.length - 1 - i];
                    }
                }
                return result;
            };
            
            // Convert baht part
            let result = '';
            const bahtNum = parseInt(baht);
            if (bahtNum === 0) {
                result = 'ศูนย์บาท';
            } else {
                result = convertGroup(bahtNum) + 'บาท';
            }
            
            // Convert satang part
            const satangNum = parseInt(satang);
            if (satangNum > 0) {
                result += satangNum === 1 ? 'หนึ่งสตางค์' : convertGroup(satangNum) + 'สตางค์';
            }
            
            return result;
        },
        formatDueDate(createdAtDate, dueDay) {
            if (!createdAtDate || !dueDay) return '-';
            
            const date = new Date(createdAtDate);
            let month = date.getMonth(); // Get current month (0-11)
            let year = date.getFullYear();
            
            // If we're past the due day, move to next month
            const currentDay = date.getDate();
            if (currentDay > dueDay) {
                // If current month is December (11), move to January of next year
                if (month === 11) {
                    month = 0;
                    year++;
                } else {
                    month++;
                }
            }
            
            const dueDate = new Date(year, month, dueDay);
            
            // Format the date
            const thaiYear = dueDate.getFullYear() + 543;
            const formattedMonth = String(dueDate.getMonth() + 1).padStart(2, '0');
            const formattedDay = String(dueDate.getDate()).padStart(2, '0');
            
            return `${formattedDay}/${formattedMonth}/${thaiYear}`;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            // Thai Buddhist year is 543 years ahead of Gregorian calendar
            const thaiYear = date.getFullYear() + 543;
            // Pad month and day with leading zeros if needed
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}/${month}/${thaiYear}`;
        },
        getPreviousMonthThai(dateString) {
            if (!dateString) return '';
            
            const date = new Date(dateString);
            // Go back one month
            date.setMonth(date.getMonth() - 1);
            
            // Thai month names
            const thaiMonths = [
                'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 
                'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 
                'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
            ];
            
            return thaiMonths[date.getMonth()];
        },
        formatNumber(value) {
            if (value === null || value === undefined) return '0.00';
                let num = parseFloat(value).toFixed(2); // Ensure two decimal places
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        // Quantity column shouldn't carry a fake ".00" - meter usage is a
        // whole number of units, only fall back to decimals if it's not.
        formatQuantity(value) {
            const num = parseFloat(value);
            if (!Number.isFinite(num)) return '0';
            const rounded = Math.round(num * 100) / 100;
            return Number.isInteger(rounded)
                ? rounded.toLocaleString()
                : rounded.toLocaleString(undefined, { maximumFractionDigits: 2 });
        },
        toMoney(value) {
            const num = Number(value);
            if (!Number.isFinite(num)) return 0;
            return Math.round(num * 100) / 100;
        },
        firstPositiveNumber(candidates = []) {
            for (const candidate of candidates) {
                const value = this.toMoney(candidate);
                if (value > 0) return value;
            }
            return 0;
        },
        getPastUnpaidTotal(bill = {}) {
            // carriedDebt is the actual unpaid balance rolled forward from
            // this tenant's previous bill(s). The past*Price fields this
            // used to sum are last month's water/electric unit cost for
            // comparison display, unrelated to whether anything is unpaid.
            return this.toMoney(bill.carriedDebt);
        },
        getWaterAfterUnit(bill = {}) {
            const usage = this.firstPositiveNumber([
                bill.usageWater,
                bill.waterUsage,
                bill.usageMeter,
            ]);
            const fallbackStart = this.toMoney(this.data_bill?.user_sign_contract?.startWater);
            const afterUnit = this.firstPositiveNumber([
                bill.lastWaterUnit,
                bill.waterUnit,
                bill.meterUnit,
                bill.currentWaterUnit,
            ]);
            if (afterUnit > 0) return afterUnit;
            if (fallbackStart > 0 && usage > 0) return this.toMoney(fallbackStart + usage);
            return fallbackStart;
        },
        getWaterBeforeUnit(bill = {}) {
            const afterUnit = this.getWaterAfterUnit(bill);
            const usage = this.firstPositiveNumber([
                bill.usageWater,
                bill.waterUsage,
                bill.usageMeter,
            ]);
            const fallbackStart = this.toMoney(this.data_bill?.user_sign_contract?.startWater);
            if (afterUnit <= 0 && usage <= 0) {
                return fallbackStart;
            }
            return this.toMoney(Math.max(0, afterUnit - usage));
        },
        getElectricAfterUnit(bill = {}) {
            const usage = this.firstPositiveNumber([
                bill.usageElectric,
                bill.electricUsage,
                bill.usageMeter,
            ]);
            const fallbackStart = this.toMoney(this.data_bill?.user_sign_contract?.startElectric);
            const afterUnit = this.firstPositiveNumber([
                bill.lastElectricUnit,
                bill.lastElecUnit,
                bill.electicUnit,
                bill.electricUnit,
                bill.currentElectricUnit,
            ]);
            if (afterUnit > 0) return afterUnit;
            if (fallbackStart > 0 && usage > 0) return this.toMoney(fallbackStart + usage);
            return fallbackStart;
        },
        getElectricBeforeUnit(bill = {}) {
            const afterUnit = this.getElectricAfterUnit(bill);
            const usage = this.firstPositiveNumber([
                bill.usageElectric,
                bill.electricUsage,
                bill.usageMeter,
            ]);
            const fallbackStart = this.toMoney(this.data_bill?.user_sign_contract?.startElectric);
            if (afterUnit <= 0 && usage <= 0) {
                return fallbackStart;
            }
            return this.toMoney(Math.max(0, afterUnit - usage));
        },
        getCurrentChargeSubtotal(bill = {}) {
            return this.toMoney(
                this.toMoney(bill.roomPrice) +
                this.toMoney(bill.waterPrice) +
                this.toMoney(bill.electricPrice) +
                this.toMoney(bill.communalPrice) +
                this.toMoney(bill.otherPrice)
            );
        },
        getInvoiceChargeSubtotal(bill = {}) {
            return this.toMoney(this.getCurrentChargeSubtotal(bill) + this.getPastUnpaidTotal(bill));
        },
        getInvoiceVat(bill = {}) {
            return this.toMoney(bill.vat);
        },
        getInvoiceGrandTotal(bill = {}) {
            const itemizedTotal = this.toMoney(this.getInvoiceChargeSubtotal(bill) + this.getInvoiceVat(bill));
            if (itemizedTotal > 0) {
                return itemizedTotal;
            }
            return this.toMoney(bill.total);
        },
        getCreditApplied(bill = {}) {
            // Leftover credit from a prior overpayment (see approvePayment)
            // that got applied to this bill automatically at creation time.
            return this.toMoney(bill.creditApplied);
        },
        getNetPayable(bill = {}) {
            return this.toMoney(Math.max(0, this.getInvoiceGrandTotal(bill) - this.getCreditApplied(bill)));
        },
        // mode: 'download' triggers a named file download, 'preview' opens
        // the PDF in a new tab instead.
        async generatePDF(data, mode = 'download') {
            this.data_bill = data;

            try {
                // Get building ID from store
                const buildingId = this.$store.state.building;
                let qrCodeUrl = null;
                let bankName = '';
                let accountName = '';
                let accountNumber = '';

                // Fetch QR code + bank details from building-pay-methods endpoint
                try {
                const response = await axios.get(
                    `https://api.resguru.app/api/building-pay-methods?filters[building][id][$eq]=${buildingId}&populate=QRCode`
                );


                const payMethod = response.data?.data?.[0]?.attributes;
                if (payMethod) {
                    bankName = payMethod.bankName || '';
                    accountName = payMethod.accountName || '';
                    accountNumber = payMethod.accountNumber || '';
                    if (payMethod.QRCode?.data?.attributes) {
                        qrCodeUrl = `https://api.resguru.app${payMethod.QRCode.data.attributes.url}`;
                    }
                }
                } catch (error) {
                console.error("Error fetching QR code:", error);
                // Continue without QR code if there's an error
                }

                // Ensure the document fonts are actually loaded before
                // html2canvas snapshots the DOM - otherwise it can capture
                // mid-swap (default font -> Sarabun), which is a common
                // cause of Thai vowel/tone marks rendering misaligned.
                if (document.fonts && document.fonts.ready) {
                    await document.fonts.ready;
                }

                this.$nextTick(() => {
                const content = this.$refs.pdfContent;
                if (!content) {
                    console.error("PDF content not found");
                    return; // Exit if content is not found
                }

                // Add QR code + bank details into the header grid's middle
                // column (qrSlot) - was appended after the signature block
                // before, pushing the document past one page; putting it in
                // that already-unused column keeps everything on page 1.
                if (qrCodeUrl) {
                    const qrSlot = this.$refs.qrSlot;
                    let qrContainer = content.querySelector('.qr-code-container');
                    if (!qrContainer && qrSlot) {
                    qrContainer = document.createElement('div');
                    qrContainer.className = 'qr-code-container';
                    qrContainer.style.width = '100%';
                    qrContainer.style.display = 'flex';
                    qrContainer.style.flexDirection = 'column';
                    qrContainer.style.alignItems = 'center';

                    const qrImage = document.createElement('img');
                    qrImage.src = qrCodeUrl;
                    qrImage.style.objectFit = 'contain';
                    qrImage.alt = 'Payment QR Code';
                    qrImage.crossOrigin = 'anonymous'; // Handle cross-origin images

                    const qrLabel = document.createElement('div');
                    qrLabel.textContent = 'สแกนเพื่อชำระเงิน';
                    qrLabel.style.marginTop = '4px';
                    qrLabel.style.fontSize = '11px';
                    qrLabel.style.fontWeight = 'bold';
                    qrLabel.style.textAlign = 'center';

                    qrContainer.appendChild(qrImage);
                    qrContainer.appendChild(qrLabel);

                    if (bankName || accountName || accountNumber) {
                        const bankDetails = document.createElement('div');
                        bankDetails.style.marginTop = '2px';
                        bankDetails.style.fontSize = '10px';
                        bankDetails.style.textAlign = 'center';
                        const lines = [];
                        if (bankName) lines.push(`ธนาคาร ${bankName}`);
                        if (accountName) lines.push(`ชื่อบัญชี ${accountName}`);
                        if (accountNumber) lines.push(`เลขที่บัญชี ${accountNumber}`);
                        bankDetails.innerHTML = lines.map(line => `<div>${line}</div>`).join('');
                        qrContainer.appendChild(bankDetails);
                    }

                    qrSlot.appendChild(qrContainer);
                    }
                }

                const opt = {
                    margin: 6,
                    filename: `bill-${data.RoomNumber}.pdf`,
                    image: {
                    type: "jpeg",
                    quality: 0.98
                    },
                    html2canvas: {
                    scale: 2,
                    useCORS: true, // Enable CORS for images
                    logging: false, // Disable logging for better performance
                    allowTaint: true // Allow cross-origin images
                    },
                    jsPDF: {
                    unit: "mm",
                    format: "a4",
                    orientation: "portrait"
                    }
                };

                // Generate the PDF, then either open it in a new tab for
                // preview or trigger a real named download, per mode.
                // window.open(bloburl) doesn't carry a filename through to
                // the browser's save dialog, so download() is used for the
                // actual download path.
                html2pdf()
                    .from(content)
                    .set(opt)
                    .toPdf()
                    .get("pdf")
                    .then(function (pdf) {
                    console.log("สร้าง PDF สำเร็จ");
                    if (mode === 'preview') {
                        window.open(pdf.output("bloburl"), "_blank");
                    } else {
                        const blob = pdf.output("blob");
                        download(blob, opt.filename, "application/pdf");
                    }

                    // Clean up - remove QR code container if we added it
                    if (qrCodeUrl) {
                        const qrContainer = content.querySelector('.qr-code-container');
                        if (qrContainer) {
                        qrContainer.remove();
                        }
                    }
                    })
                    .catch(function (error) {
                    console.error("Error generating PDF:", error);

                    // Clean up - remove QR code container if we added it
                    if (qrCodeUrl) {
                        const qrContainer = content.querySelector('.qr-code-container');
                        if (qrContainer) {
                        qrContainer.remove();
                        }
                    }
                    });
                });
            } catch (error) {
                console.error("Error in PDF generation process:", error);
            }
        }
    },
};
</script>
<style>
/* Explicit font on the PDF content itself (not just inherited from #app) -
   html2canvas snapshots the DOM, so the font needs to be reliably resolved
   on this subtree rather than relying on inheritance timing. */
.pdf-document {
  font-family: 'Sarabun', 'Angsana New', Arial, sans-serif;
  line-height: 1.35;
}

/* Custom styling for the invoice table */
.invoice-table {
  border: 2px solid #333; /* Darker border for the whole table */
}

.invoice-table th,
.invoice-table td {
  border: 1px solid #333; /* Darker border for cells */
}

.invoice-table thead tr {
  background-color: #f0f0f0; /* Light gray header */
}

.invoice-table thead th {
  /* The table's compact 1.35 line-height (inherited from .pdf-document)
     clips Thai vowel/tone marks on bold header text - give the header
     row its own taller line-height so nothing touches the cell border. */
  line-height: 1.6;
}

/* Alternating row colors: transparent and light gray */
.invoice-table .row-odd {
  background-color: #f5f5f5; /* Very light gray */
}

.invoice-table .row-even {
  background-color: transparent; /* See-through */
}

.invoice-table tfoot tr {
  background-color: #f0f0f0; /* Light gray footer */
}

.qr-code-container img {
  width: 85px !important;
  height: 85px !important;
  min-width: 85px !important;
  min-height: 85px !important;
  max-width: 85px !important;
  max-height: 85px !important;
  /* object-fit: none rendered at the source image's native size and just
     clipped it to the box - not predictable if the uploaded QR isn't
     already exactly 85x85. contain always scales the whole QR (never
     crops into its pattern) down/up to fit the fixed box, so the box size
     alone is a reliable prediction of the final rendered size. */
  object-fit: contain !important;
}

.watermarked {
  position: absolute;
  opacity: 0.05;
  width: 100%;
  height: auto;
}

.signature-line {
  display: inline-block;
  width: 150px; /* Reduced width */
  border-bottom: 1px solid black; /* Creates the line */
  margin: 0 4px; /* Reduced spacing */
  vertical-align: bottom; /* Aligns it properly */
}
</style>